// API Services for real-time gold and currency data

const GOLD_API_URL = 'https://api.gold-api.com/price/XAU';
const SILVER_API_URL = 'https://api.gold-api.com/price/XAG';
const CURRENCY_API_URL = 'https://api.frankfurter.dev/latest';

// Fetch latest gold price in USD from gold-api.com
export const fetchGoldPrice = async () => {
  try {
    const response = await fetch(GOLD_API_URL);
    if (!response.ok) throw new Error('Failed to fetch gold price');
    const data = await response.json();
    return {
      price: data.price || 4350.00,
      date: data.updatedAt || new Date().toISOString(),
      success: true
    };
  } catch (error) {
    console.error('Gold API Error:', error);
    // Fallback to approximate current market price
    return { price: 4350.00, date: new Date().toISOString(), success: false };
  }
};

// Fetch latest silver price in USD
export const fetchSilverPrice = async () => {
  try {
    const response = await fetch(SILVER_API_URL);
    if (!response.ok) throw new Error('Failed to fetch silver price');
    const data = await response.json();
    // Note: gold-api.com silver price seems inflated, use ratio calculation
    return {
      price: data.price || 32.50,
      date: data.updatedAt || new Date().toISOString(),
      success: true
    };
  } catch (error) {
    console.error('Silver API Error:', error);
    return { price: 32.50, date: new Date().toISOString(), success: false };
  }
};

// Fetch currency exchange rates
export const fetchExchangeRates = async (baseCurrency = 'USD') => {
  try {
    const response = await fetch(`${CURRENCY_API_URL}?from=${baseCurrency}`);
    if (!response.ok) throw new Error('Failed to fetch exchange rates');
    const data = await response.json();
    return {
      rates: data.rates,
      base: data.base,
      date: data.date,
      success: true
    };
  } catch (error) {
    console.error('Currency API Error:', error);
    // Fallback rates
    return {
      rates: { USD: 1, EUR: 0.92, TRY: 38.45, AED: 3.67 },
      base: 'USD',
      date: new Date().toISOString(),
      success: false
    };
  }
};

// Fetch specific currency pair
export const fetchCurrencyPair = async (from, to) => {
  try {
    const response = await fetch(`${CURRENCY_API_URL}?from=${from}&to=${to}`);
    if (!response.ok) throw new Error('Failed to fetch currency pair');
    const data = await response.json();
    return {
      rate: data.rates[to],
      from: data.base,
      to: to,
      date: data.date,
      success: true
    };
  } catch (error) {
    console.error('Currency Pair API Error:', error);
    return { rate: 1, from, to, success: false };
  }
};
